module.exports = __webpack_public_path__ + "static/media/DigitalMarketing.3041f17d.JPG";